import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';

const schema: JSONSchema7 = {
    title: 'Content List Editor',
    type: 'object',
    required: [],
    properties: {
        query: {
            type: 'string',
            title: 'Graphql query',
            description: 'A graphql query',
            default: '',
        },
        transform: {
            type: 'string',
            title: 'Transform function',
            description: 'A transform function to transform the graphql query results',
            default: '',
        },
    },
};

const ContentListEditorSchema: commonTypes.IWidget = {
    schema,
    uiSchema: {
        query: {
            'ui:widget': 'JSEditor',
        },
        transform: {
            'ui:widget': 'JSEditor',
        },
    },
    templateView: () => <></>,
    id: 'contentListEditor',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ContentListEditorSchema;
